// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7956) return "static/chunks/7956-65dbf784b8ace28c.js";
	if (chunkId === 1389) return "static/chunks/1389-f4a1e3430aebf2fe.js";
	if (chunkId === 6037) return "static/chunks/6037-4b91bfee692dc5a9.js";
	if (chunkId === 5840) return "static/chunks/5840-fbd07832c292f5b9.js";
	if (chunkId === 5089) return "static/chunks/5089-099e9a53f6c2b7b7.js";
	if (chunkId === 8041) return "static/chunks/8041-fc2dc066eb6751ed.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1589":"50f71c70c0e7b09c","4622":"33bff9cba37e3988","7237":"8488a596d06cd2a7","7893":"ca396bb0eb886965","7985":"7aa18e8fb55d3d52","8175":"2917cd27bb5a39f5","8399":"311dba7ba54dbdae","8834":"fff9e826b26392b2"}[chunkId] + ".js";
};